<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :loading="loading" @on-cancel="cancel"
           :width="750"
    >
      <h3 slot="header" class="modal-header">添加发票</h3>
      <div class="specialdrop">
        <Form :label-width="120" ref="formData" :rules="formRules" :model="formData">
          <FormItem label="项目名称" prop="projectFid" >
            <Select class="width250" v-model="formData.projectFid" @on-change="changeProject">
              <Option value="">请选择</Option>
              <Option v-for="(item,index) in projectList"
                      :value="item.value" :key="'keyA'+index">{{item.text}}
              </Option>
            </Select>
          </FormItem>
          <FormItem label="合同号" prop="conRentCode">
            <Input class="width250" v-model="formData.conRentCode" @on-blur="getApplyInvoiceBaseInfo" @on-change="changeContract" />
            <span class="error-color">*企业合同请使用主合同号检索！</span>
            <!--<Button type="primary" style="margin-left: 20px" size="small" @click.stop="getApplyInvoiceBaseInfo">查询-->
            <!--</Button>-->
          </FormItem>
          <FormItem label="发票抬头" prop="invoiceTitle">
            <Input class="width250" v-model="formData.invoiceTitle" disabled/>
          </FormItem>
          <FormItem label="纳税人识别号" prop="custTaxNo" v-if="formData.subjectType===3">
            <Input class="width250" v-model="formData.custTaxNo" @on-change="changeCustTaxNo"/>
          </FormItem>
          <FormItem label="费用项目" prop="list">
            <CheckboxGroup v-model="formData.list">
              <Checkbox label="ZJ" v-model="flag1">房租</Checkbox>
              <Checkbox label="FW" v-model="flag2">服务费</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="发票类型" prop="invoiceType">
            <RadioGroup v-model="formData.invoiceType" @on-change="verifyCompetencyByTaxNum">
              <Radio label="3">电子发票（普票）</Radio>
              <Radio label="1">增值税普通发票</Radio>
              <!--:disable="formData.subjectType!==3"-->
              <Radio label="2" :disabled="formData.subjectType!==3" >增值税专用发票</Radio>
            </RadioGroup>
          </FormItem>
          <div class="invoicec-ard" v-if="flag1 && formData.invoiceTitle">
            <div class="mb8">
              <div class="left1">房租可开票金额</div>
              <div class="right1">
                <Input class="width200" disabled v-model="ZJCouldInvoiceAmount"/>
              </div>
            </div>
            <div class="mb8">
              <div class="left1" style="vertical-align: middle">可开票月份</div>
              <div class="right1">
                <div>
                  <span :class="['item','ivu-btn',{'btn-primary2':ZJAll}]" @click="selectZJAll">全选</span>
                  <span class="vertical-t" v-if="ZJObj.invoiceStartDate && ZJObj.invoiceEndDate">开票周期：{{ZJObj.invoiceStartDate+" 至 "+ZJObj.invoiceEndDate}}</span>
                </div>
                <div>
                  <span
                    v-for="(item,index) in ZJObj.monthList" :key="'keyL'+index"
                    @click.stop="selectItem(item)"
                    :class="['item','ivu-btn',{'btn-primary2':item.isSelected}]">{{item.monthStr}}</span>
                </div>
              </div>
            </div>
            <FormItem label="房租开票金额" prop="invoiceAmount1" :label-width="120">
              <Input class="width200" v-model="formData.invoiceAmount1" disabled/>
              <Button type="primary" style="margin-left: 20px" size="small" @click.stop="getInvoiceAmountAndCycleByMonth('ZJ')">计算</Button>
            </FormItem>
          </div>
          <div class="invoicec-ard" v-if="flag2 && formData.invoiceTitle">
            <div class="mb8">
              <div class="left1">服务费可开票金额</div>
              <div class="right1">
                <Input class="width200" v-model="FWCouldInvoiceAmount" disabled/>
              </div>
            </div>

            <div class="mb8">
              <div class="left1" style="vertical-align: middle">可开票月份</div>
              <div class="right1">
                <div>
                  <span :class="['item','ivu-btn',{'btn-primary2':FWAll}]" @click.stop="selectFWAll">全选</span>
                  <span class="vertical-t" v-if="FWObj.invoiceStartDate && FWObj.invoiceEndDate">开票周期：{{FWObj.invoiceStartDate+' 至 '+FWObj.invoiceEndDate}}</span>
                </div>
                <div>
                  <span
                    v-for="(item,index) in FWObj.monthList" :key="'keyM'+index"
                    @click.stop="selectItem(item)"
                    :class="['item','ivu-btn',{'btn-primary2':item.isSelected}]">{{item.monthStr}}</span>
                </div>
              </div>
            </div>
            <FormItem label="服务费开票金额" prop="invoiceAmount2" :label-width="120">
              <Input class="width200" v-model="formData.invoiceAmount2" disabled/>
              <Button type="primary" style="margin-left: 20px" size="small" @click.stop="getInvoiceAmountAndCycleByMonth('FW')">计算</Button>
            </FormItem>
          </div>
          <FormItem label="邮箱" prop="recEmail" v-if="formData.invoiceType==3">
            <Input class="width250" v-model="formData.recEmail"/>
          </FormItem>
          <FormItem label="收件人" prop="receiver" v-if="formData.invoiceType!=3">
            <Input class="width250" v-model="formData.receiver"/>
          </FormItem>
          <FormItem label="邮寄电话" prop="recPhone" v-if="formData.invoiceType!=3">
            <Input class="width250" v-model="formData.recPhone"/>
          </FormItem>
          <FormItem label="邮寄地址" prop="recAddress" v-if="formData.invoiceType!=3">
            <Input class="width250" v-model="formData.recAddress"/>
          </FormItem>
        </Form>
      </div>
    </Modal>
  </div>
</template>
<script>
  import {getProjects} from "../../../../api/common";
  import {
    getApplyInvoiceBaseInfo,
    verifyCompetencyByTaxNum,
    getInvoiceAmountAndMonth,
    getInvoiceAmountAndCycleByMonth,
    saveInvoiceInfo
  } from "../../../../api/invoice";
  export default {
    name: "",
    components: {},
    props: {
      n: {
        type: Number,
        default: 0
      },
    },
    computed: {
      ZJSelected() {
        let ret = []
        this.ZJObj.monthList.forEach(ele => {
          ele.isSelected && (ret.push(ele))
        })
        return ret
      },
      FWSelected() {
        let ret = []
        this.FWObj.monthList.forEach(ele => {
          ele.isSelected && (ret.push(ele))
        })
        return ret
      },
      ZJAll: {
        get: function () {
          return this.ZJObj.monthList.length > 0 && this.ZJObj.monthList.every(ele => {
            return ele.isSelected == true
          })
        },
        set: function (value) {
          this.ZJObj.monthList.forEach(ele => {
            if (value) {
              ele.isSelected = true
            }
            else {
              ele.isSelected = false
            }
          })
        }
      },
      FWAll: {
        get: function () {
          return this.FWObj.monthList.length > 0 && this.FWObj.monthList.every(ele => {
            return ele.isSelected === true
          })
        },
        set: function (value) {
          this.FWObj.monthList.forEach(ele => {
            if (value) {
              ele.isSelected = true
            }
            else {
              ele.isSelected = false
            }
          })
        }
      }

    },
    watch: {
      n() {
        this.formData={
          "competencyId": "",
            "conRentCode": "",
            "custTaxNo": "",
            "invoiceMonthDtos": [],
            "invoiceTitle": "",
            "invoiceType": '3',
            "projectFid": "",
            "projectName": "",
            "recAddress": "",
            "recPhone": "",
            "receiver": "",
            "subjectType": "",
            "recEmail":"",
            // signSubjectType:'',
            list: [],
            invoiceAmount2: '',
            invoiceAmount1: '',
          // invoiceStartDate:'',

        },
        this.$refs['formData'].resetFields()
        this.flag1=false
        this.flag2=false
        this.isShow = true
      },
      flag1(value) {
        if (value == false) {
          return
        }
        if (!this.formData.invoiceTitle) {
          this.$Message.info('请输入有效合同号')
          this.flag1 = false
          this.formData.list = []
          return
        }
        this.getInvoiceAmountAndMonth('ZJ')
      },
      flag2(value) {
        if (value == false) {
          return
        }
        if (!this.formData.invoiceTitle) {
          this.$Message.info('请输入有效合同号')
          this.flag2 = false
          this.formData.list = []
          return
        }
        this.getInvoiceAmountAndMonth('FW')
      },
      ZJSelected(){
        this.formData.invoiceAmount1=''
        this.ZJObj.invoiceStartDate=""
        this.ZJObj.invoiceEndDate=""

      },
      FWSelected(){
        this.formData.invoiceAmount2=''
        this.FWObj.invoiceStartDate=""
        this.FWObj.invoiceEndDate=""
      }
    },
    data() {
      const validateEmail = (rule, value, callback) => {
        const pattern = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
        if(!pattern.test(value)){
          callback(new Error('输入正确的邮箱'));
        } else{
          callback();
        }
      }
      return {
        flag1: false,
        flag2: false,
        formRules: {
          // "competencyId": "",
          "conRentCode": [
            {required: true, message: '请输入合同号', trigger: 'blur', type: 'string'}
          ],
          "custTaxNo": [
            {required: true, message: '请输入纳税人识别号', trigger: 'blur', type: 'string'}
          ],
          // "invoiceEndDate": "",
          // "invoiceStartDate": "",
          "invoiceTitle": [
            {required: true, message: '请输入发票抬头', trigger: 'change', type: 'string'}
          ],
          "invoiceType": [
            {required: true, message: '请选择发票类型', trigger: 'change', type: 'string'}
          ],
          "projectFid": [
            {required: true, message: '请选择项目', trigger: 'change', type: 'string'}
          ],
          // "projectName": "",
          "recAddress": [
            {required: true, message: '请输入地址', trigger: 'blur', type: 'string'}
          ],
          "recPhone": [
            {required: true, message: '输入正确的联系方式', trigger: 'blur', validator: this.validatecontactPhone2,}
          ],
          "receiver": [
            {required: true, message: '请输入地址', trigger: 'blur', type: 'string'}
          ],
          // "subjectType": "",
          invoiceAmount2: [
            {required: true, message: '点击计算', trigger: 'change', validator: this.validateNumber}
          ], //服务费开票金额
          list: [
            {required: true, message: '请选择费用项目', type: 'array', min: 1, trigger: 'change'}
          ],
          invoiceAmount1: [
            {required: true, message: '点击计算', trigger: 'change', validator: this.validateNumber}
          ], //房租开票金额
          //邮箱
          "recEmail":[{ required:true, validator:validateEmail, trigger:'blur' }],
        },
        projectList: [],
        formData: {
          "competencyId": "",
          "conRentCode": "",
          "custTaxNo": "",
          "invoiceMonthDtos": [],
          "invoiceTitle": "",
          "invoiceType": '3',
          "projectFid": "",
          "projectName": "",
          "recAddress": "",
          "recPhone": "",
          "receiver": "",
          "subjectType": "",
          "recEmail":"",
          // signSubjectType:'',
          list: [],
          invoiceAmount2: '',
          invoiceAmount1: '',
          // invoiceStartDate:'',

        },
        ZJCouldInvoiceAmount: '',//房租可开票金额
        FWCouldInvoiceAmount: '',
        loading: true,
        isShow: false,
        ZJObj: {
          "feeType": "ZJ",
          "invoiceAmount": "",
          "tempInvoiceMonth": "string",
          monthList: [],
          "invoiceEndDate": "",
          "invoiceStartDate": "",
        },
        FWObj: {
          "feeType": "FW",
          "invoiceAmount": "",
          "tempInvoiceMonth": "string",
          monthList: [],
          "invoiceEndDate": "",
          "invoiceStartDate": "",
        },
      }
    },
    methods: {
      changeCustTaxNo(){
        this.formData.invoiceType='3'
      },
      validateNumber(rule, value, callback) {
        let pattern =/^(-?\d+)(\.\d+)?$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      changeContract(){
        this.FWObj= {
          "feeType": "FW",
            "invoiceAmount": "",
            "tempInvoiceMonth": "",
            monthList: [],
            "invoiceEndDate": "",
            "invoiceStartDate": "",
        }
        this.ZJObj= {
          "feeType": "ZJ",
            "invoiceAmount": "",
            "tempInvoiceMonth": "",
            monthList: [],
            "invoiceEndDate": "",
            "invoiceStartDate": "",
        }
        this.formData.invoiceAmount1=''
        this.formData.invoiceAmount2=''
        this.flag1=false
        this.flag2=false
        this.formData.list=[]
        this.formData.invoiceTitle = ''
        this.formData.receiver =''
        this.formData.custTaxNo = ''
        this.formData.recPhone = ''
        this.formData.recAddress = ""
        this.formData.subjectType = ""
        this.formData.recEmail=""
        // this.formData.signSubjectType=''
      },
      changeProject(){
        this.FWObj= {
          "feeType": "FW",
          "invoiceAmount": "",
          "tempInvoiceMonth": "",
          monthList: [],
          "invoiceEndDate": "",
          "invoiceStartDate": "",
        }
        this.ZJObj= {
          "feeType": "ZJ",
          "invoiceAmount": "",
          "tempInvoiceMonth": "",
          monthList: [],
          "invoiceEndDate": "",
          "invoiceStartDate": "",
        }
        this.formData.invoiceAmount1=''
        this.formData.invoiceAmount2=''
        this.flag1=false
        this.flag2=false
        this.formData.list=[]
        this.formData.invoiceTitle = ''
        this.formData.receiver =''
        this.formData.custTaxNo = ''
        this.formData.recPhone = ''
        this.formData.recAddress = ""
        this.formData.subjectType = ""
        this.formData.recEmail=""
        this.formData.conRentCode=""
        // this.formData.signSubjectType=''
      },
      saveInvoiceInfo(){
        this.formData.invoiceMonthDtos=[]
        if(this.flag1){
          //this.ZJObj.invoiceAmount=this.formData.invoiceAmount1
          //this.ZJObj.tempInvoiceMonth=this.ZJSelected.join(',')
          this.ZJSelected.forEach(ele => {
            this.formData.invoiceMonthDtos.push(ele);
          })

        }
        if(this.flag2){
          //this.FWObj.invoiceAmount=this.formData.invoiceAmount2
          //this.FWObj.tempInvoiceMonth=this.FWSelected.join(',')
          this.FWSelected.forEach(ele => {
            this.formData.invoiceMonthDtos.push(ele)
          })
        }
        saveInvoiceInfo(this.formData).then(res=>{
          this.$Message.success('发票添加成功')
          this.$emit('done')
          this.isShow=false
        }).catch(error=>{
          this.changeLoading()
        })

      },
      getInvoiceAmountAndCycleByMonth(type) {
        let params
        //+校验

        if (type === 'ZJ') {
          if(this.ZJSelected.length===0){
            this.$Message.info('请选择月份')
            return
          }
          params = this.ZJSelected;
        }else {
          if(this.FWSelected.length===0){
            this.$Message.info('请选择月份')
            return
          }
          params = this.FWSelected;
        }
        getInvoiceAmountAndCycleByMonth(params).then(res => {
          if (type === "ZJ") {
            this.formData.invoiceAmount1 = res.data.invoiceAmount
            this.ZJObj.invoiceStartDate=res.data.startInvoiceCycle
            this.ZJObj.invoiceEndDate=res.data.endInvoiceCycle
          }
          else {
            this.formData.invoiceAmount2 = res.data.invoiceAmount
            this.FWObj.invoiceStartDate=res.data.startInvoiceCycle
            this.FWObj.invoiceEndDate=res.data.endInvoiceCycle
          }
        }).catch(error => {

        })

      },
      selectFWAll() {
        this.FWAll = !this.FWAll
      },
      selectItem(item) {
        item.isSelected = !item.isSelected
      },
      selectZJAll() {
        this.ZJAll = !this.ZJAll
      },
      getInvoiceAmountAndMonth(type) {
        let params = {
          contractCode: this.formData.conRentCode,
          freeType: type
        }
        getInvoiceAmountAndMonth(params).then(res => {
          let list = []
          res.data.invoiceMonth.forEach(ele => {
            list.push({
              ...ele,
              isSelected: false
            })
          })
          if (type === 'ZJ') {
            this.ZJObj.monthList = list
            this.ZJCouldInvoiceAmount = res.data.invoiceAmount
          }
          if (type === 'FW') {
            this.FWObj.monthList = list
            this.FWCouldInvoiceAmount = res.data.invoiceAmount
          }
        }).catch(error => {})
      },
      verifyCompetencyByTaxNum(value) {
        if (value == 1) {
            this.formData.recEmail = "";
            return
        }else if(value==3) {
          this.formData.receiver =''
          this.formData.recPhone = ''
          this.formData.recAddress = ""
        }else if(value ==2) {
          this.formData.recEmail = "";
          if (!this.formData.custTaxNo || !this.formData.projectFid) {
            this.$Message.info('请选择项目或输入纳税人识别号')
            this.formData.invoiceType = '3'
            return
          }
          let params = {
            custTaxNo: this.formData.custTaxNo,
            projectFid:this.formData.projectFid
          }
          verifyCompetencyByTaxNum(params).then(res => {
            this.formData.competencyId=res.data
          }).catch(error => {
            this.formData.invoiceType = '3'
          })
        }
      },
      getApplyInvoiceBaseInfo() {
        if (!this.formData.conRentCode) {
          return
        }
        let params = {
          contractCode: this.formData.conRentCode,
          projectFid:this.formData.projectFid
        }
        getApplyInvoiceBaseInfo(params).then(res => {
          this.formData.invoiceTitle = res.data.invoiceTitle
          this.formData.receiver = res.data.receiver
          this.formData.custTaxNo = res.data.taxIdfa
          this.formData.recPhone = res.data.recPhone
          this.formData.recAddress = res.data.recAddress
          this.formData.recEmail = res.data.recEmail
          this.formData.subjectType = res.data.signSubjectType
          // this.formData.signSubjectType=res.data.signSubjectType

        }).catch(error => {
          // this.formData.invoiceTitle = 'test'
        })

      },
      validatecontactPhone2(rule, value, callback) {
        let pattern = /^1\d{10}$/
        if (!pattern.test(value)) {
          callback(new Error('输入正确的手机号'));
        }
        callback();
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        this.$refs['formData'].validate(bool => {
          if (bool) {
            this.saveInvoiceInfo()
          }
          else {
            this.changeLoading()
          }
        })
      },
      cancel() {
      }
    },
    created() {
      getProjects().then(res => {
        this.projectList = res.data
      }).catch(error => {
      })
    }
  }
</script>

<style scoped>
  .vertical-t {
    vertical-align: top;
  }

  .inlineblock {
    display: inline-block;
  }

  .lin32 {
    line-height: 32px;
  }

  .width200 {
    width: 200px;
  }

  .invoicec-ard {
    /*width: 80%;*/
    border: 1px solid rgb(220, 220, 220);
    padding: 10px 0;
    box-sizing: border-box;
    margin-bottom: 20px;
  }

  .width250 {
    width: 300px;
  }

  .left1, .right1 {
    display: inline-block;
    /*line-height: 2;*/
    vertical-align: top;
    line-height: 32px;
  }

  .left1 {
    width: 110px;
    text-align: right;
    margin-right: 10px;
    vertical-align: middle;
  }
  .right1{
    width:525px ;
  }

  .item {
    /*vertical-align: middle;*/
    display: inline-block;
    /*width: 60px;*/
    margin-right: 15px;
    margin-bottom: 15px;
  }

</style>
